<template>
  <div>
    <el-dialog
      @close="closeDialog"
      :visible="dialogVisible"
      @opened="onOpenedDialog"
      title="提示"
      width="300px">
      <div class="warp">
        <div class="img">
          <!-- 调试信息 -->
          <div v-if="!qrcodeUrl" style="color: red; font-size: 12px; margin-bottom: 10px;">
            二维码URL为空
          </div>
          <!-- 图片加载失败的提示 -->
          <div v-else-if="imageLoadFailed" style="text-align: center; padding: 20px; color: #999;">
            <div style="font-size: 48px; margin-bottom: 10px;">📱</div>
            <div style="font-size: 12px;">二维码图片加载失败</div>
            <div style="font-size: 11px; color: #ccc; margin-top: 5px;">请使用手机扫码访问小程序</div>
          </div>
          <img
            v-else
            :src="qrcodeUrl"
            alt="二维码"
            @error="handleImageError"
            @load="handleImageLoad" />
        </div>
        <div class="tip">扫码进入小程序</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// 导入底部已有的小程序二维码图片
import miniprogrmImage from '@/assets/miniprogrm.jpg';

export default {
  name: 'GlobalDialog',
  data() {
    return {
      // 直接使用底部已有的小程序二维码图片
      qrcodeUrl: miniprogrmImage,
      imageLoadFailed: false, // 标记图片是否加载失败
    };
  },
  methods: {
    handleImageError(event) {
      console.error('[GlobalDialog] 图片加载失败');
      console.error('[GlobalDialog] 失败的URL:', this.qrcodeUrl);
      this.imageLoadFailed = true;
      
      // 显示友好的错误提示
      this.$message({
        message: '二维码图片加载失败，请检查网络连接或稍后重试',
        type: 'error',
        duration: 3000
      });
    },
    handleImageLoad() {
      console.log('[GlobalDialog] ✓ 图片加载成功');
      this.imageLoadFailed = false;
    },
    closeDialog() {
      this.$store.commit('setGlobalDialogVisible', {
        visible: false,
        path: 'pages/index/index',
      });
    },
    onOpenedDialog() {
      // 不再需要调用 API，直接使用固定的二维码图片
      console.log('[GlobalDialog] 使用固定的小程序二维码图片');
      this.imageLoadFailed = false;
    },
  },
  computed: {
    dialogVisible() {
      return this.$store.state.globalDialogVisible;
    },
  },
};
</script>
<style lang="scss" scoped>
.warp {
  text-align: center;
  .img {
    width: 200px;
    height: 200px;
    border: solid 1px #f1f1f1;
    border-radius: 8px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tip {
    margin-top: 20px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
